import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { StudentSkillStates } from '../../models/StudentSkillState';

export interface StudentSkillsState {
  value: StudentSkillStates[] | null;
}

const initialState: StudentSkillsState = { value: null };

export const studentSkillsSlice = createSlice({
  name: 'studentSkills',
  initialState,
  reducers: {
    setStudentSkills: (state: StudentSkillsState, action: PayloadAction<StudentSkillStates[]>) => {
      state.value = action.payload;
    },
  },
});

export const selectedStudentSkillStates = (state: RootState) => state.studentSkills.value;

export const { setStudentSkills } = studentSkillsSlice.actions;

export default studentSkillsSlice.reducer;
